import React, { useState, useEffect } from   'react';
import { useParams, useNavigate} from 'react-router-dom';
import MenuEnlacesDX from './Componentes/MenuEnlacesDX';
import HeaderDXReloj from './Componentes/HeaderDXReloj';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import 'react-datepicker/dist/react-datepicker.css';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import { useAuth } from '../../Auth/AuthContext';
import apiService from './../../Auth/apiService';
import { useForm } from 'react-hook-form';

export default function DXResultado() {
    const { iddx } = useParams();
    const { idrecepcion } = useParams();
    const { token, user } = useAuth();
    const [estadoDx, setEstadoDx] = useState('');
    const Navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({})
    const [swalConfirmAction, setSwalConfirmAction] = useState(null);
    const [Cargando, setCargando] = useState(false)
    const [btnFinalizarDxDisabled, setBtnFinalizarDxDisabled] = useState(false);
    const [motivosnoentrega, setMotivosnoentrega] = useState([]);
    const [datosFormulario, setDatosFormulario] = useState(null);
    const [fechaInicioAtencion, setFechaInicioAtencion] = useState(null);
    const { watch, handleSubmit, register, setValue, reset, formState: { errors }} = useForm({ 
            defaultValues: {
                iddx: '',
            } 
        }
    );
    const Mensaje = (title, text, icon, confirmAction = null) => {
        setSwalConfirmAction(() => confirmAction);
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
            confirmButtonText: 'Aceptar',
        });
    };
    function irDiagnosticodx(){
        Navigate('/dx/diagnosticodx');
    }
    async function FinalizarDiagnostico(){
        setBtnFinalizarDxDisabled(true);
        setCargando(true);
        const url = '/diagnostico/finalizardx';
        const obj = { iddx: iddx, idrecepcion: idrecepcion, usrid: user };
        await apiService.post(url, obj, token)
            .then((response) => {
                if (response.status === 200) {
                    Mensaje(
                        'Finalizar',
                        response.data.message + ' ' + response.data.caracterizacioncreada,
                        'success',
                        irDiagnosticodx
                    );
                }
            })
            .catch((error) => {
                if (error.status === 422) {
                    Mensaje('Finalizar', JSON.stringify(error.response.data.errors), 'error');
                } else if (error.status === 409) {
                    Mensaje('Finalizar', JSON.stringify(error.response.data), 'error');
                } else {
                    Mensaje('Finalizar', `Error al finalizar el diagnostico: ${error}`, 'error');
                    console.error('Error fetching data:', error);
                }
            })
            .finally(() => {
                setBtnFinalizarDxDisabled(false);
                setCargando(false);
            });
    }               

    const InicializarFormulario = async () => {
        const url = '/diagnostico/crearformularioresultado';
        const obj = { iddx: iddx };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setFechaInicioAtencion(result.recepcion.repFechahoraatencion || null);
            setEstadoDx(result.estadodx);
            if (result.motivosnoentrega) {
                setMotivosnoentrega(result.motivosnoentrega);
            } else {
                Mensaje('Error', result.data.message, 'error');
            }
            if (result.resultado) {
                setDatosFormulario(result.resultado);                
            } else {
                Mensaje('Error', result.data.message, 'error');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        if (motivosnoentrega && motivosnoentrega.length > 0 && datosFormulario) {
            FormReset(datosFormulario);
            setDatosFormulario(null);
        }
    }, [datosFormulario]);

    const FormReset = (data) => {
        reset((prevValues) => ({
            ...prevValues,
            iddx: data?.iddx || '',
            res_6_1_observacionesatencion: data?.res_6_1_observacionesatencion || '',
            res_6_1_1_factores_incidencia: data?.res_6_1_1_factores_incidencia || '',
            res_6_1_2_factor_determinante: data?.res_6_1_2_factor_determinante || '',
            res_6_2_1_aplica_entrega: data?.res_6_2_1_aplica_entrega || false,
            res_6_2_1_1_si_no_aplica_indicar_motivo: data?.res_6_2_1_1_si_no_aplica_indicar_motivo || '',
            res_6_2_2_temporalidad: data?.res_6_2_2_temporalidad || false,
            res_6_2_3_alimentos: data?.res_6_2_3_alimentos || false,
            res_6_2_4_kits: data?.res_6_2_4_kits || false,
            res_6_2_5_alimentos_efectivo: data?.res_6_2_5_alimentos_efectivo || false,
            res_6_2_6_subsidiariedad_temporalidad: data?.res_6_2_6_subsidiariedad_temporalidad || false,
            res_6_2_7_subsidiariedad_alimentos: data?.res_6_2_7_subsidiariedad_alimentos || false,
            res_6_2_8_subsidiariedad_kits: data?.res_6_2_8_subsidiariedad_kits || false,
            res_6_2_9_albergue: data?.res_6_2_9_albergue || false,
        }));
    }; 
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/diagnostico/guardarresultado';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                setEstadoDx(response.data.estadodx);
                Mensaje('Guardar', JSON.stringify(response.data.message), 'success');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors), 'error');
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data), 'error');
            }else{
                Mensaje('Guardar', `Error al guardar los datos: ${error}`, 'error');
                console.error('Error fetching data:', error);
            }
        } finally {
            setCargando(false);
        }
    }; 
    useEffect(() => {
        InicializarFormulario();
    }, [])
    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Diagnostico base - Resultado"
                idCabezaFamilia="1"
                url="/dx/diagnosticodx"
                nombreurl="Diagnostico dx"
                nombreform="Resultado"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
              <div className="container-fluid">
                    {Cargando && <div className="centered">
                      <div><progress value={null} /></div>
                    </div>}
              </div>
            </section>
            <section className="content">
                <HeaderDXReloj startTime={fechaInicioAtencion} estadoDx={estadoDx} />
                <MenuEnlacesDX iddx={iddx} idrecepcion={idrecepcion} buttonActive={7} estadoDx={estadoDx}/>

                <div id="formDiagnostico" className="card">
                    <div className="row">
                    <div className="col-md-12">
                        <div className="nav-tabs-custom">
                        <div className="tab-content">
                            <h4>6. RESULTADO DIAGNOSTICO</h4>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card">
                                    <div className='card-body'>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label htmlFor='txtres_6_1__observacionesAtencion'>6.1. Observacion atenci&oacute;n</label>  
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">   
                                                    <textarea
                                                        id="txtres_6_1__observacionesAtencion"
                                                        maxLength="5000"
                                                        rows="5"
                                                        className="form-control"
                                                        placeholder="Observaciones"
                                                        {...register('res_6_1_observacionesatencion', { required: 'Este campo es obligatorio' })}
                                                        onChange={e => {
                                                            const upperValue = e.target.value.toUpperCase();
                                                            const filteredValue = upperValue.replaceAll(/[^A-Z0-9,. ]/gi, '');
                                                            setValue('res_6_1_observacionesatencion', filteredValue);
                                                        }}
                                                    />
                                                    {errors.res_6_1_observacionesatencion && (
                                                        <span className="text-danger">{errors.res_6_1_observacionesatencion.message}</span>
                                                    )}
                                                </div>
                                            </div>
                                            </div>
                                            <div className="card-header">
                                            <h6 className="card-title"><b>6.2. Solicitud de Atenci&oacute;n Inmediata</b></h6>
                                            </div>
                                            <div className="row">
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('res_6_2_1_aplica_entrega')}
                                                        onChange={(e) => {
                                                            setValue("res_6_2_1_aplica_entrega", e.target.checked)
                                                            if (e.target.checked) {
                                                                setValue("res_6_2_1_1_si_no_aplica_indicar_motivo", "")
                                                            }else{
                                                                setValue("res_6_2_2_temporalidad", "")
                                                                setValue("res_6_2_3_alimentos", "")
                                                                setValue("res_6_2_4_kits", "")
                                                                setValue("res_6_2_5_alimentos_efectivo", "")
                                                                setValue("res_6_2_6_subsidiariedad_temporalidad", "")
                                                                setValue("res_6_2_7_subsidiariedad_alimentos", "")
                                                                setValue("res_6_2_8_subsidiariedad_kits", "")
                                                                setValue("res_6_2_9_albergue", "")
                                                            }
                                                        }}
                                                        className="custom-control-input" id="res_6_2_1_aplica_entrega"/>
                                                    <label className="custom-control-label" htmlFor="res_6_2_1_aplica_entrega"> 6.2.1. ¿Aplica para entrega de las medidas de Atenci&oacute;n Inmediata?</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                <label htmlFor="res_6_2_1_1_si_no_aplica_indicar_motivo">6.2.1.1 Si no Aplica para entrega, indicar motivo</label>
                                                <select
                                                    id="res_6_2_1_1_si_no_aplica_indicar_motivo"
                                                    className="form-control"
                                                    {...register('res_6_2_1_1_si_no_aplica_indicar_motivo', { required: watch('res_6_2_1_aplica_entrega') ? false : 'Este campo es obligatorio' })}
                                                    disabled={watch('res_6_2_1_aplica_entrega')}
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {motivosnoentrega.map((motivo) => (
                                                        <option key={motivo.id} value={motivo.id}>
                                                            {motivo.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.res_6_2_1_1_si_no_aplica_indicar_motivo && (
                                                    <span className="text-danger">{errors.res_6_2_1_1_si_no_aplica_indicar_motivo.message}</span>
                                                )}
                                                <span hidden id="infoslcres_6_2_1_1_si_no_aplica_indicar_motivo">Si la familia NO Aplica para entrega de Ayuda Humanitaria por Atencion Inmediata, Indique motivo.</span>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="card-header">
                                            <h6 className="card-title"><b>Asistencia por Alcald&iacute;a</b></h6>
                                            </div>
                                            <div className="row">                      
                                            <div id="divAsistemporalidad" className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                    <input type="checkbox" 
                                                        {...register('res_6_2_2_temporalidad')}
                                                        onChange={(e) => {
                                                            setValue("res_6_2_2_temporalidad", e.target.checked)
                                                        }}
                                                        className="custom-control-input" id="res_6_2_2_temporalidad"
                                                        disabled={!watch('res_6_2_1_aplica_entrega')}
                                                        />
                                                    <label className="custom-control-label" htmlFor="res_6_2_2_temporalidad"> 6.2.2. Temporalidad</label>
                                                    </div>
                                                </div>
                                            </div>                      
                                            <div id="divAsisAlimentos" className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('res_6_2_3_alimentos')}
                                                            onChange={e => setValue('res_6_2_3_alimentos', e.target.checked)}
                                                            className="custom-control-input"
                                                            id="res_6_2_3_alimentos"                                                            
                                                            disabled={!watch('res_6_2_1_aplica_entrega')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="res_6_2_3_alimentos">
                                                            6.2.3. Alimentos
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                </div>
                                            </div>                     
                                            <div id="divAsisKits" className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('res_6_2_4_kits')}
                                                            onChange={e => setValue('res_6_2_4_kits', e.target.checked)}
                                                            className="custom-control-input"
                                                            id="res_6_2_4_kits"
                                                            disabled={!watch('res_6_2_1_aplica_entrega')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="res_6_2_4_kits">
                                                            6.2.4. Kits
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="divAsisAlimEfectivo" className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('res_6_2_5_alimentos_efectivo')}
                                                            onChange={e => setValue('res_6_2_5_alimentos_efectivo', e.target.checked)}
                                                            className="custom-control-input"
                                                            id="res_6_2_5_alimentos_efectivo"
                                                            disabled={!watch('res_6_2_1_aplica_entrega')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="res_6_2_5_alimentos_efectivo">
                                                            6.2.5. Alimentos en efectivo
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="card-header">
                                            <h6 className="card-title"><b>Asistencia por Subsidiariedad</b></h6>
                                            </div>
                                            <div className="row">
                                            <div id="divSubsidiariedadTemporalidad" className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('res_6_2_6_subsidiariedad_temporalidad')}
                                                            onChange={e => setValue('res_6_2_6_subsidiariedad_temporalidad', e.target.checked)}
                                                            className="custom-control-input"
                                                            id="res_6_2_6_subsidiariedad_temporalidad"
                                                            disabled={!watch('res_6_2_1_aplica_entrega')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="res_6_2_6_subsidiariedad_temporalidad">
                                                            6.2.6. Temporalidad
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="divSubsidiariedadAlimentos" className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('res_6_2_7_subsidiariedad_alimentos')}
                                                            onChange={e => setValue('res_6_2_7_subsidiariedad_alimentos', e.target.checked)}
                                                            className="custom-control-input"
                                                            id="res_6_2_7_subsidiariedad_alimentos"
                                                            disabled={!watch('res_6_2_1_aplica_entrega')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="res_6_2_7_subsidiariedad_alimentos">
                                                            6.2.7. Alimentos
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="divSubsidiariedadKits" className="col-md-3">
                                                <div className="form-group">
                                                    <div className="custom-control custom-switch">
                                                        <input
                                                            type="checkbox"
                                                            {...register('res_6_2_8_subsidiariedad_kits')}
                                                            onChange={e => setValue('res_6_2_8_subsidiariedad_kits', e.target.checked)}
                                                            className="custom-control-input"
                                                            id="res_6_2_8_subsidiariedad_kits"
                                                            disabled={!watch('res_6_2_1_aplica_entrega')}
                                                        />
                                                        <label className="custom-control-label" htmlFor="res_6_2_8_subsidiariedad_kits">
                                                            6.2.8. Kit
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="card-header">
                                            <h6 className="card-title"><b>Asistencia albergue</b></h6>
                                            </div>
                                            <div className="row">
                                            <div id="divAlbergue" className="col-md-4">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('res_6_2_9_albergue')}
                                                        onChange={e => setValue('res_6_2_9_albergue', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="res_6_2_9_albergue"
                                                        disabled={!watch('res_6_2_1_aplica_entrega')}
                                                    />
                                                    <label className="custom-control-label" htmlFor="res_6_2_9_albergue">
                                                        6.2.9. Alojamiento temporal
                                                    </label>
                                                </div>
                                            </div>
                                            </div> 
                                        </div>
                                        <div className="card-footer">
                                            <div className="row">
                                                <div className="col-md-2">
                                                <button id="btnDxActualizarResultado" type="submit" className="btn btn-block btn-primary btn-sm">Actualizar
                                                </button>
                                                </div>
                                                {estadoDx >=8 && <div className="col-md-2 pull-right">
                                                    <button
                                                        id="btnFinalizarDiagnostico"
                                                        type="button"
                                                        onClick={FinalizarDiagnostico}
                                                        className="btn btn-block btn-success btn-sm"
                                                        data-tooltip-id="tooltiparriba"
                                                        data-tooltip-content="Al finalizar el diagnostico se generara los registros en el modulo de caracterizacion"
                                                        disabled={btnFinalizarDxDisabled}
                                                    >
                                                        Finalizar diagnostico
                                                    </button>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>    
                 <SweetAlert2
                        {...swalProps}
                        didClose={() => {
                            setSwalProps({});
                            setSwalConfirmAction(null);
                        }}
                        onConfirm={() => {
                            setSwalProps({});
                            const confirmAction = swalConfirmAction;
                            setSwalConfirmAction(null);
                            if (confirmAction) {
                                confirmAction();
                            }
                        }}
                    />
                    <Tooltip id="tooltiparriba" place="right"/>   
            </section>
            {/* /.content */}
        </div>
        
    )
  }